/* eslint-disable quote-props */
import { toRem, toRems } from 'helpers/theme'

const style = ({ theme }) => ({
    // marginTop: toRem(-150),

    img: {
        width: '100%'
    },

    [theme.breakpoints.down('md')]: {
        // marginTop: toRem(150)
    },

    '.ContactMap-button': {
        margin: toRems([20, 0]),
        padding: toRems([0, 10, 0, 20]),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: theme.colors.blueMidAlt,
        width: 'auto',
        minHeight: toRem(60),
        borderRadius: toRem(4),
        color: theme.colors.white,
        fontSize: toRem(14),
        cursor: 'pointer',

        svg: {
            display: 'flex'
        },

        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },

    '.CountryInfo': {
        background: theme.colors.blueLight,
        borderRadius: 4,
        padding: 20,

        [theme.breakpoints.up('md')]: {
            maxWidth: 'fit-content',
            margin: '-40px auto 0 auto',
            padding: 30
        },

        '&-title': {
            color: theme.colors.goldDark,
            fontSize: 20,
            fontWeight: 500,
            lineHeight: 1,
            marginBottom: 15,

            [theme.breakpoints.up('md')]: {
                fontSize: 24
            }
        },

        '&-content': {
            display: 'grid',
            gridTemplateColumns: '1fr',
            gridGap: 20,

            [theme.breakpoints.up('md')]: {
                gridGap: 85,
                gridTemplateColumns: 'auto auto'
            },

            '*': {
                fontSize: 16,
                lineHeight: 1.75
            }
        },

        '&-placeholder': {
            [theme.breakpoints.up('md')]: {
                minHeight: 211,
                padding: 30,
                margin: '-40px auto 0 auto'
            }
        }
    },

    '.Contact-map': {
        maxWidth: 1156,
        padding: toRems([0, 20]),
        margin: '0 auto',

        svg: {
            // padding: toRems([0, 30]),
            width: '100%',
            height: 'auto'
        }
    },

    '.country': {
        transition: 'fill 0.5s ease'
    },

    '.ContactItem': {
        '&-wrapper': {
            display: 'flex',
            alignItems: 'center'
        },
        '&-icon': {
            display: 'flex',
            alignItems: 'center',
            marginRight: 5,

            svg: {
                padding: 0
            }
        }
    }
})

export default style
